import { useState } from "react";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      q: "O que é a Hoobuy Spreadsheet?",
      a: "A Hoobuy Spreadsheet é uma planilha completa em português com milhares de links organizados por categorias. Ela reúne os melhores produtos de moda, sneakers, streetwear, bolsas e acessórios com vendedores verificados, facilitando suas compras internacionais.",
    },
    {
      q: "Como usar a Hoobuy Spreadsheet?",
      a: "Basta acessar nossa planilha, escolher a categoria desejada e clicar nos links dos produtos. Cada link leva diretamente ao vendedor verificado. A planilha é organizada por categorias como Tênis, Moletons, Camisetas, Jaquetas e muito mais.",
    },
    {
      q: "A Hoobuy é segura para comprar?",
      a: "Sim! Nossa equipe verifica manualmente todos os links, vendedores e produtos antes de adicioná-los à Hoobuy Spreadsheet. Trabalhamos apenas com fornecedores que possuem bom feedback e histórico confiável. Além disso, mantemos atualizações semanais para garantir a qualidade.",
    },
    {
      q: "Qual o melhor vendedor na Hoobuy?",
      a: "Nossa planilha destaca os vendedores mais bem avaliados em cada categoria. Recomendamos sempre verificar o feedback recente e as avaliações antes de finalizar sua compra. Os vendedores com selo de verificação na nossa planilha são os mais confiáveis.",
    },
    {
      q: "Como encontrar produtos baratos na Hoobuy Spreadsheet?",
      a: "Utilize os filtros da nossa planilha por categoria e preço. As seções de 'Outros Itens' e 'Acessórios' costumam ter ótimos achados com preços acessíveis. Também atualizamos semanalmente com novas promoções e descontos.",
    },
    {
      q: "Como comprar no Brasil usando a Hoobuy Spreadsheet?",
      a: "Após encontrar o produto desejado na nossa planilha, você pode utilizar um agente de compras internacional para fazer o pedido e enviar para o Brasil. Nossa planilha inclui guias completos sobre como comprar, calcular frete e evitar taxas extras.",
    },
    {
      q: "Quanto custa o frete da Hoobuy?",
      a: "O frete varia de acordo com o peso do produto, destino e método de envio escolhido. Em média, para o Brasil, os custos começam em torno de R$ 40-60 para itens leves. Nossa planilha inclui estimativas de frete para ajudar no planejamento da sua compra.",
    },
    {
      q: "Vale a pena usar a Hoobuy Spreadsheet?",
      a: "Com certeza! A Hoobuy Spreadsheet economiza horas de pesquisa, oferece links verificados, vendedores confiáveis e uma organização completa por categorias. É a ferramenta ideal para quem quer comprar produtos de qualidade com segurança e praticidade.",
    },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-3">
          Perguntas Frequentes
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          Tire suas dúvidas sobre a Hoobuy Spreadsheet
        </p>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/60 bg-background-50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${
                      openIndex === idx ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* FAQ Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.q,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.a,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}